import { RepositoryFactory } from '@/http/api/RepositoryFactory'
const MainWireRepository = RepositoryFactory.get('RailwayRepository')['MainWireRepository'];

import { DefaultStoreActions } from '@/store/utils/requests'
const { get, create } = DefaultStoreActions(MainWireRepository)

export const STORE_MODULE_NAME = 'mainWire';
export const STORE_MODULE_CONFIG =  {
    namespaced: true,
    state: {
        isVerticalMenuActive: false,
    },
    getters: {},
    mutations: {},
    actions: {
        fetch: get,
        create: create,
    },
}
